var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('IxRes',{attrs:{"context":{0: _vm.fullName}}},[_vm._v("Areas.FieldRecordSystem.SR_Action.MultiFieldNutrientValuesHeader")]),_vm._v(":\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }